var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltipTrigger",staticClass:"tw-relative"},[_vm._t("default"),(_vm.isVisible && _vm.content)?_c('div',{staticClass:"tw-pointer-events-none tw-fixed tw-z-50 tw-rounded-lg tw-bg-dark-gray tw-px-1.5 tw-py-1 tw-text-xs tw-text-white tw-shadow-lg tw-transition-opacity tw-duration-200",style:({
      left: `${_vm.position.x}px`,
      top: `${_vm.position.y}px`,
      transform: 'translate(-50%, -50%)',
    })},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }